import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["servingsInput", "quantity"]
  static values = { base: Number }

  increase() {
    const current = parseInt(this.servingsInputTarget.value) || this.baseValue
    this.servingsInputTarget.value = current + 1
    this.scale()
  }

  decrease() {
    const current = parseInt(this.servingsInputTarget.value) || this.baseValue
    if (current > 1) {
      this.servingsInputTarget.value = current - 1
      this.scale()
    }
  }

  scale() {
    const servings = parseFloat(this.servingsInputTarget.value) || this.baseValue
    const ratio = servings / this.baseValue

    this.quantityTargets.forEach(el => {
      const original = parseFloat(el.dataset.original)
      if (!isNaN(original)) {
        const scaled = original * ratio
        el.textContent = this.formatQuantity(scaled)
      }
    })
  }

  formatQuantity(value) {
    if (Number.isInteger(value)) return value.toString()

    // Round to 1 decimal for clean display
    const rounded = Math.round(value * 10) / 10
    if (Number.isInteger(rounded)) return rounded.toString()
    return rounded.toFixed(1)
  }
}
